import { htcmdService } from 'js/services/htcmd.service';

/* eslint-disable no-underscore-dangle */

export const existKambiDOM = () => document.querySelector('#KambiBC') !== null;

export const detachKambiDOM = () => {
    const client = document.querySelector('#KambiBC');
    const betslip = document.querySelector('#mod-KambiBC-betslip-container');

    if (client) {
        document.body.insertAdjacentElement('beforeend', client);
    }

    client?.classList.add('hidden');
    betslip?.classList.add('hidden');
};

export const attachKambiDOM = (parent, kambiContainer) => {
    const client = document.querySelector('#KambiBC') ?? kambiContainer;
    const betslip = document.querySelector('#mod-KambiBC-betslip-container');

    if (client) {
        parent.insertAdjacentElement('beforeend', client);
    }

    client?.classList.remove('hidden');
    betslip?.classList.remove('hidden');

    window.dispatchEvent(new CustomEvent('resize'));
};

export const navigateHome = ({ initialRoute }) => {
    // hack to initiate showing of the home page of Kambi
    if (!initialRoute) {
        return;
    }

    if (window.location.hash === '') {
        window.location.hash = initialRoute;
    }
};

export const setConfig = ({ config, customerSettings, showLoginPopup, setKambiInitialized }) => {
    window._kc = { ...config };
    window.customerSettings = {
        ...customerSettings,
        notification: (event) => {
            const isNativeApp = htcmdService.isEnabled;

            switch (event?.name) {
                case 'pageRendered':
                    setKambiInitialized(true);
                    break;

                case 'loginRequested':
                    if (isNativeApp) {
                        htcmdService.logout();
                        return;
                    }

                    showLoginPopup();
                    break;

                default:
                    // noop
            }
        }
    };
};
